module.exports = __webpack_public_path__ + "img/model_26.bb44a742.jpg";